import { z } from "zod";

import { currentWorkDate } from "@/lib/format.ts";

const FUTURE = "A data não pode ser futura.";

export const actualDatesSchema = z
	.object({
		actualStart: z
			.string()
			.min(1, "Informe o início real.")
			.refine((value) => value <= currentWorkDate(), { message: FUTURE }),
		actualEnd: z
			.string()
			.refine((value) => value === "" || value <= currentWorkDate(), {
				message: FUTURE,
			}),
	})
	.refine(
		(values) =>
			values.actualEnd === "" || values.actualEnd >= values.actualStart,
		{
			message: "O término real deve ser igual ou posterior ao início real.",
			path: ["actualEnd"],
		},
	);

export type ActualDatesFormValues = z.infer<typeof actualDatesSchema>;
